import { render, staticRenderFns } from "./EntryParts.vue?vue&type=template&id=00a6647f"
import script from "./EntryParts.vue?vue&type=script&lang=js"
export * from "./EntryParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports